import { render } from "./SquareGrid.vue?vue&type=template&id=3b76fd54&scoped=true"
import script from "./SquareGrid.vue?vue&type=script&lang=js"
export * from "./SquareGrid.vue?vue&type=script&lang=js"

import "./SquareGrid.vue?vue&type=style&index=0&id=3b76fd54&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b76fd54"],['__file',"src/components/UI/spinner/SquareGrid.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b76fd54"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b76fd54', __exports__)) {
    api.reload('3b76fd54', __exports__)
  }
  
  module.hot.accept("./SquareGrid.vue?vue&type=template&id=3b76fd54&scoped=true", () => {
    api.rerender('3b76fd54', render)
  })

}


export default __exports__